export default "__VITE_ASSET__DKx7E3$2__"